<div class="container loan-app">

    <lgv-loading-indicator
        *ngIf="(isLoading$ | async) || (isSubmitting$ | async) || (lgvFormSvc.isLoadingFormState$ | async)"></lgv-loading-indicator>


    <!-- <ng-container>
        <div>Show <a (click)="onShowModel()"> Model</a> | <a (click)="onShowSchema()"> Schema</a> | <a
                (click)="onShowFormState()"> FormState</a> | <a (click)="onShowFormStateThisLevel()"> FormState This
                Level</a>
        </div>
    </ng-container> -->

    <ng-container
        *ngIf="((lgvClientSvc.isBetaClient$ | async) && !(savedLoanApp$ | async)?.loanInfo?.loanNumber && lgvAuthMgrSvc.IsClient)">
        <div class="header-container" *ngIf="savedLoanApp$ | async as loanApp">
            <div class="side-header">
                <span class="header-text">Let's get your verified approval!</span>
                <span style="margin-top: 10px;">Complete the below steps to get your pre-approval letter.</span>
            </div>
            <div class="address-card">
                <div *ngIf="loanApp?.loanInfo?.subjectPropertyAddress as addr" style="margin-bottom: 5px;">
                    <span *ngIf="!addr?.street && !!addr?.city && !addr?.state && !!addr?.zip">Address
                        TBD</span>
                    <span *ngIf="addr?.street">{{addr?.street}}, </span>
                    <span *ngIf="addr?.city">{{addr?.city}}, </span>
                    <span *ngIf="addr?.state">{{addr?.state}} </span>
                    <span>{{addr?.zip}}</span>
                </div>
                <div class="highlighted-text orange rt">
                    {{loanApp?.loanTimeline?.activeStatus?.name}}
                </div>
            </div>
            <div class="Vert-40"></div>
        </div>
        <div style="border: 1px solid rgb(215, 215, 215); margin: 0px -60px 20px -60px;">
        </div>
    </ng-container>



    <div class="row" *ngIf="!(isLoading$ | async) && !(lgvFormSvc.isLoadingFormState$ | async)" class="form-gen">
        <div class="col-12">
            <ng-container
                *ngIf="{hasFields: lgvFormSvc.hasFields$ | async, hasFieldsOtherThanRepeaters: lgvFormSvc.hasFieldsOtherThanRepeaters$ | async, hasGroups: lgvFormSvc.hasGroups$ | async, hasRepeatingSectionSummary: lgvFormSvc.hasRepeatingSectionSummary$ | async, hasRepeatingItem: lgvFormSvc.hasRepeatingItem$ | async, parentAppObj: lgvFormSvc.parentAppObj$ | async, appObj: lgvFormSvc.appObj$ | async} as statusWrapper">

                <!-- Page Mode - Default -->
                <ng-container *ngIf="(pageMode$ | async) === 'Default'">

                    <!--Summary Outline-->
                    <ng-container *ngIf="!statusWrapper.parentAppObj && statusWrapper.appObj">
                        <!-- <div class="alert alert-warning">Summary Outline</div> -->
                        <div>
                            <div>

                                <div>
                                    <a *ngIf="((lgvClientSvc.isBetaClient$ | async) && (savedLoanApp$ | async)?.loanInfo?.loanNumber) || !(lgvClientSvc.isBetaClient$ | async) || !lgvAuthMgrSvc.IsClient"
                                        (click)="onReturnToCallingPage()"><fa-icon icon="arrow-left"></fa-icon>
                                        Return to Loan Details</a>
                                </div>
                                <div class="float-start">
                                    <h3 *ngIf="(pctComplete$ | async) > 0">{{(displayConfiguration
                                        |async)?.formHeaderInProgress}}</h3>
                                    <h3 *ngIf="(pctComplete$ | async) <= 0">{{(displayConfiguration
                                        |async)?.formHeaderStart}}</h3>
                                </div>
                                <div style="clear:both"></div>
                                <div class="Vert-20"></div>
                            </div>

                            <div class="brandedProgressBar">
                                <mat-progress-bar mode="determinate" [value]="pctComplete$ | async"></mat-progress-bar>
                            </div>
                            <div class="progressBarMsg">{{pctCompleteMsg$ | async}}</div>

                            <div *ngFor="let fieldObj of fields$ | async; index as i">
                                <div *ngIf="fieldObj.fieldGroup || fieldObj.fieldArray">
                                    <ng-container
                                        *ngIf="lgvFormSvc.observeChangeSummaryForLevel$(i, -1, true) | async as summary">
                                        <div *ngIf="!summary.isHidden" class="alert alert-loan-app summary"
                                            [ngClass]="lgvFormSvc.statusLabelFromSummary(summary)"
                                            (click)="lgvFormSvc.navigate(i,-1)">
                                            <div class="row">
                                                <div class="col-6">
                                                    <span *ngIf="fieldObj?.props?.icon as icon"><fa-icon
                                                            [icon]="icon"></fa-icon></span>{{fieldObj?.props?.label}}
                                                </div>
                                                <div class="col-6" style="text-align:right">
                                                    <div>
                                                        <fa-icon class="status-icon Complete"
                                                            [icon]="['far', 'circle-check']"
                                                            *ngIf="lgvFormSvc.statusLabelFromSummary(summary) === 'Complete'"></fa-icon>
                                                        <fa-icon class="status-icon Complete" [icon]="['far', 'circle']"
                                                            *ngIf="lgvFormSvc.statusLabelFromSummary(summary) !== 'Complete'"></fa-icon>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Review and Submit (Button Only) -->
                            <div class="alert alert-loan-app summary" (click)="onReviewAndSubmit()">
                                <div class="row">
                                    <div class="col-12">
                                        <span><fa-icon icon="file-circle-check"></fa-icon></span>Review & Submit
                                    </div>
                                </div>
                            </div>

                        </div>
                    </ng-container>

                    <!--Group w/ Groups-->
                    <ng-container
                        *ngIf="statusWrapper.parentAppObj && statusWrapper.appObj && statusWrapper.hasGroups && !statusWrapper.hasFields && !statusWrapper.hasRepeatingSectionSummary">
                        <!-- <div class="alert alert-warning">Group w/ Groups</div> -->
                        <div>
                            <div><a (click)="lgvFormSvc.navigateToParentNode()"><fa-icon icon="arrow-left"></fa-icon>
                                    Return</a></div>
                                <br>
                            <lgv-section-title-navigation
                                [title]="lgvFormSvc.pageTitle$ | async"></lgv-section-title-navigation>

                            <ng-container *ngIf="fields$ | async as fields">
                                <div *ngIf="fields[0] as firstFieldObj">
                                    <div *ngFor="let fieldObj of firstFieldObj?.fieldGroup; index as i">

                                        <ng-container
                                            *ngIf="lgvFormSvc.observeChangeSummaryForLevel$(curLevel1, i, true) | async as summary">

                                            <!-- <ng-container *ngIf="summary.isHidden">
                                                    <div><b>{{fieldObj?.props?.label}} - HIDDEN</b></div>
                                                </ng-container> -->

                                            <div class="alert alert-loan-app section-summary" *ngIf="!summary.isHidden">
                                                <div style="padding:10px">
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <b>{{fieldObj?.props?.label}}</b>
                                                        </div>
                                                        <div class="col-6" style="text-align:right">
                                                            <div>
                                                                <button class="btn white"
                                                                    (click)="lgvFormSvc.navigate(curLevel1, i)"
                                                                    [disabled]="lgvFormSvc.isReadOnlyMode">{{lgvFormSvc.editButtonLabelFromSummary(summary)}}</button>
                                                            </div>
                                                        </div>
                                                        <lgv-section-summary [summary]="summary"
                                                            [level1Param]="curLevel1" [level2Param]="i"
                                                            [sectionLabel]=""
                                                            [showHeaderRow]="false"></lgv-section-summary>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                    </div>
                                </div>
                            </ng-container>

                            <div>
                                <a (click)="lgvFormSvc.navigateToPreviousSection()">Back</a>
                                <div class="float-end">
                                    <button style="margin-left:20px;" class="btn btn-primary"
                                        (click)="lgvFormSvc.navigateToNextSectionSummary()">Next</button>
                                </div>
                            </div>

                        </div>

                    </ng-container>

                    <!--Form-->
                    <ng-container
                        *ngIf="statusWrapper.parentAppObj && !statusWrapper.hasRepeatingSectionSummary && (!statusWrapper.hasGroups || (statusWrapper.hasRepeatingItem && statusWrapper.hasFields))">
                        <!-- <div class="alert alert-warning">Form</div> -->
                        <div><a (click)="lgvFormSvc.navigateToParentNode()"><fa-icon icon="arrow-left"></fa-icon>
                                Return</a></div>
                        <lgv-section-title-navigation></lgv-section-title-navigation>
                        <span *ngIf="lgvFormSvc.pageTitle$ | async as pageTitle"><b>{{pageTitle}}</b></span>
                        <div class="Vert-15"></div>

                        <!-- If Summary has no fields, then generate them here as soon as form is shown -->
                        <ng-container *ngIf="lgvFormSvc.getChangeSummaryForCurrentLevel() as formSummary">
                            <ng-container>{{syncSummaryFields()}}</ng-container>
                        </ng-container>

                        <form [formGroup]="form" (ngSubmit)="submit()" class="form-gen" (change)="onFormChange($event)">
                            <formly-form [model]="lgvFormSvc.dataModel$ | async" [fields]="fields$ | async"
                                (modelChange)="onModelChange($event)" [options]="formlyOptions$ | async"
                                [form]="form"></formly-form>
                        </form>
                        <div style="margin-top: 10px;">
                            <a (click)="lgvFormSvc.navigateToPreviousSection()">Back</a>
                            <div class="float-end" *ngIf="lgvFormSvc.isPreApplicationMode">
                                <a (click)="lgvFormSvc.navigateToNextSection()">Skip</a>
                                <button style="margin-left:20px;" class="btn btn-primary"
                                    [disabled]="lgvFormSvc.isLookingFromZip$ | async"
                                    (click)="lgvFormSvc.navigateToNextSection()">Save & Next</button>
                            </div>
                            <div class="float-end" *ngIf="!lgvFormSvc.isPreApplicationMode">
                                <button style="margin-left:20px;" class="btn btn-primary"
                                    (click)="lgvFormSvc.saveForm(); lgvFormSvc.returnHome()">Save</button>
                            </div>
                        </div>

                    </ng-container>

                    <!--Repeating Section Summary-->
                    <ng-container *ngIf="statusWrapper.parentAppObj && statusWrapper.hasRepeatingSectionSummary">
                        <!-- <div class="alert alert-warning">Repeating Section</div> -->
                        <form [formGroup]="form" class="form-gen">
                            <formly-form [model]="lgvFormSvc.dataModel$ | async" [fields]="fields$ | async"
                                (modelChange)="onModelChange($event)" [options]="formlyOptions$ | async"
                                [form]="form"></formly-form>
                        </form>
                    </ng-container>

                </ng-container>

                <!-- REVIEW AND SUBMIT -->
                <ng-container *ngIf="(pageMode$ | async) === 'ReviewAndSubmit'">

                    <ng-container *ngIf="!statusWrapper.parentAppObj && statusWrapper.appObj">
                        <!-- <div class="alert alert-warning">Review & Submit</div> -->

                        <!-- Header Info and Progress Bar -->
                        <div>
                            <div>
                                <div>
                                    <a *ngIf="lgvFormSvc.isPreApplicationMode"
                                        (click)="onExitReviewAndSubmit()"><fa-icon icon="arrow-left"></fa-icon>
                                        Return</a>
                                    <a *ngIf="!lgvFormSvc.isPreApplicationMode"
                                        (click)="onReturnToCallingPage()"><fa-icon icon="arrow-left"></fa-icon>
                                        Return to Loan Details</a>
                                </div>
                                <lgv-section-title-navigation [title]="headerMsg"></lgv-section-title-navigation>
                                <div class="Vert-20"></div>
                            </div>

                            <ng-container *ngIf="lgvFormSvc.isPreApplicationMode">
                                <div class="brandedProgressBar">
                                    <mat-progress-bar mode="determinate"
                                        [value]="pctComplete$ | async"></mat-progress-bar>
                                </div>
                                <div class="progressBarMsg">{{pctCompleteMsg$ | async}}</div>
                            </ng-container>


                            <div *ngIf="lgvFormSvc.isPreApplicationMode">Expand each section to see your
                                information.</div>
                            <div *ngIf="!lgvFormSvc.isPreApplicationMode">Expand each section to review your
                                information.</div>
                            <div class="Vert-15"></div>

                        </div>

                        <!-- Loop top level sections -->
                        <div *ngFor="let outerFieldObj of fields$ | async; index as level_1_index">
                            <ng-container *ngIf="outerFieldObj.fieldGroup || outerFieldObj.fieldArray">

                                <ng-container
                                    *ngIf="lgvFormSvc.getChangeSummaryForLevel(level_1_index, -1, true) as summary">

                                    <div *ngIf="!summary.isHidden" class="alert alert-loan-app"
                                        [ngClass]="lgvFormSvc.cssClassFromSummaryStatus(summary)">

                                        <div>
                                            <mat-expansion-panel class="clear-formatting"
                                                (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                                                <mat-expansion-panel-header>
                                                    <div>
                                                        <!-- <span *ngIf="outerFieldObj?.props?.icon as icon"><fa-icon [icon]="icon"></fa-icon></span> -->
                                                        <span
                                                            class="primary-color review-submit-title">{{outerFieldObj?.props?.label}}</span>
                                                    </div>
                                                </mat-expansion-panel-header>


                                                <!-- Expansion Content -->
                                                <div class="expansion-content-wrapper">

                                                    <!-- Fields at first level -->
                                                    <ng-container
                                                        *ngIf="summary?.fieldList?.length > 0 && outerFieldObj?.type !== 'repeatingSectionSummary'">
                                                        <!-- <div class="alert alert-warning">Fields at first level</div> -->
                                                        <lgv-section-summary [summary]="summary"
                                                            [level1Param]="level_1_index" [level2Param]="-1"
                                                            [sectionLabel]=""></lgv-section-summary>
                                                    </ng-container>

                                                    <!-- Non-Array Objects -->
                                                    <ng-container
                                                        *ngIf="outerFieldObj.fieldGroup && outerFieldObj.fieldGroup.length && !outerFieldObj.fieldArray">
                                                        <ng-container
                                                            *ngFor="let lvl2Object of outerFieldObj.fieldGroup; index as level_2_index">
                                                            <!-- <div class="alert alert-warning">Non-Array Objects</div> -->

                                                            <!-- Sub Section Summary -->
                                                            <ng-container
                                                                *ngIf="lgvFormSvc.getChangeSummaryForLevel(level_1_index, level_2_index, true) as lvl2Summary">

                                                                <ng-container *ngIf="!lvl2Summary.isHidden">
                                                                    <lgv-section-summary [summary]="lvl2Summary"
                                                                        [level1Param]="level_1_index"
                                                                        [level2Param]="level_2_index"
                                                                        [sectionLabel]="lvl2Object?.props?.label"></lgv-section-summary>
                                                                </ng-container>


                                                            </ng-container>
                                                        </ng-container>
                                                    </ng-container>

                                                    <!-- Array Objects -->
                                                    <ng-container *ngIf="outerFieldObj.fieldArray">
                                                        <!-- <div class="alert alert-warning">Array Objects</div> -->

                                                        <div class="row">

                                                            <div class="col-12" style="text-align:right">
                                                                <button class="btn white"
                                                                    (click)="lgvFormSvc.navigate(level_1_index, -1)"
                                                                    [disabled]="lgvFormSvc.isReadOnlyMode">
                                                                    <!-- {{lgvFormSvc.editButtonLabelFromSummary(summary)}} -->
                                                                    Edit
                                                                </button>
                                                            </div>

                                                            <!-- Note  *** Looping on Summary Objects, not Form.  Formly Field Obj Meta Data doesn't generate unless viewed once in Form -->
                                                            <ng-container
                                                                *ngIf="lgvFormSvc.getChangeSummaryForLevel(level_1_index, -1, false) as lvl2Summary">

                                                                <!-- Loop array items -->
                                                                <ng-container
                                                                    *ngFor="let itemKey of lgvFormSvc.getChangeSummaryKeysForArrayItems(level_1_index); index as array_index">
                                                                    <div><b>{{outerFieldObj?.fieldArray?.props?.label}}
                                                                            {{(+array_index +1).toString()}}</b>
                                                                    </div>
                                                                    <div
                                                                        *ngIf="lgvFormSvc.getChangeSummaryForKey(itemKey) as arrayItemSummary">

                                                                        <lgv-section-summary
                                                                            [summary]="arrayItemSummary"
                                                                            [level1Param]="level_1_index"
                                                                            [level2Param]="-1"
                                                                            [arrayIndex]="array_index"
                                                                            [sectionLabel]="outerFieldObj?.fieldArray?.props?.label + ' ' + (array_index +1)"
                                                                            [showHeaderRow]="false"></lgv-section-summary>

                                                                    </div>

                                                                </ng-container>
                                                            </ng-container>

                                                        </div>
                                                    </ng-container>
                                                </div>

                                            </mat-expansion-panel>

                                        </div>


                                    </div>


                                </ng-container>


                            </ng-container>
                        </div>

                        <!-- Terms & Agreements -->
                        <div>Terms & Agreements</div>

                        <div class="row" *ngFor="let term of (lgvFormSvc.terms$ | async); let i=index">
                            <div class="col-12">
                                <mat-checkbox
                                    *ngIf="lgvFormSvc.isPreApplicationMode || !lgvFormSvc.getTermValue(term.key)"
                                    [checked]="term?.defaultValue" (change)="onTermChanged($event, term.key)">
                                    {{lgvFormSvc.isApplyingForCoBorrower$.value ? 'We' : 'I'}} {{term?.label}}
                                </mat-checkbox>
                                <mat-checkbox
                                    *ngIf="!lgvFormSvc.isPreApplicationMode && lgvFormSvc.getTermValue(term.key)"
                                    [checked]="lgvFormSvc.getTermValue(term.key)" [disableRipple]="true"
                                    [disabled]="true">
                                    {{lgvFormSvc.isApplyingForCoBorrower$.value ? 'We' : 'I'}} {{term?.label}}
                                </mat-checkbox>
                                <br>
                                <a style="margin-left: 32px;" (click)="openViewTermsModal(i)">View Terms</a>
                                <div class="Vert-15"></div>
                            </div>
                        </div>

                        <div *ngIf="lgvFormSvc.isPreApplicationMode">
                            <a (click)="onExitReviewAndSubmit()">Back</a>
                            <div class="float-end">
                                <button style="margin-left:20px;" class="btn btn-primary" (click)="onSubmit()"
                                    [disabled]="!(isFormComplete$ | async) || (isSubmitting$ | async)">Submit
                                    App</button>
                            </div>
                        </div>

                    </ng-container>



                </ng-container>


            </ng-container>


        </div>
    </div>



</div>